/**
 * Import dependencies.
 */
import {h, Component} from 'preact';
import classnames from 'classnames/dedupe';

/**
 * Import local dependencies.
 */

/**
 * Import styles.
 */
import './index.scss';

/**
 * Create the component.
 */



export default class Footer extends Component {
    render({
           'class': className,
           children,
           fixed,
           ...props
         }, state, context) {
    const classes = classnames('mdc-footer', {
      // 
    }, className);
    return (
      <footer class={classes} {...props}>{children}</footer>
    );
  }
}




// WEBPACK FOOTER //
// ../q-mdc/elements/material-footer/index.js